<div class="main-wrapper">
  <div class="container">
    <h2 class="heading" [ngClass]="section?.class">{{section?.header}}</h2>
    <div class="divider"></div>
    <div class="sub-heading" *ngIf="section?.sub_header">
      {{section?.sub_header}}
    </div>
    <ngx-glide [showArrows]="false" [showBullets]="false" [perView]="1.1" [bound]="true" [dragThreshold]="false" [breakpoints]="breakpoints" *ngIf="isMobile;else desktop" [perTouch]="1">
      <ng-container *ngTemplateOutlet="tab_content"></ng-container>
    </ngx-glide>

    <ng-template #desktop>
      <div class="tab-sections row" [ngClass]="{'know-more': section.link}">
        <!-- <ng-container *ngTemplateOutlet="tab_content"></ng-container> -->
        <button mat-raised-button *ngFor="let cause of section?.data_images; let i=index" [class]="'mat-raised-button tabs order-'+i" [ngClass]="{'selected': cause?.selected && section.link}" (click)="toggle(cause, i)">
          <div [hidden]="cause?.selected" [class]="cause.icon"></div>
          <div [hidden]="cause?.selected" class="divider small" [class]="section?.class"></div>
          <h5 [hidden]="cause?.selected" class="title">{{cause.text}}</h5>
          <div [hidden]="cause?.selected" class="link">{{cause.link}}</div>
          <div [hidden]="!cause?.selected" class="title font15" [ngClass]="{'mt5neg': section?.class === 'animal-fundraising','font11': section?.class === 'educational' || section?.class === 'transplant', 'font9': section?.class === 'sports'}">{{cause.invertText}}</div>
        </button>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #tab_content>
  <div class="tab-sections" *ngFor="let cause of section?.data_images; let i=index" [ngClass]="{'know-more': section.link}">
    <button mat-raised-button  [class]="'mat-raised-button tabs order-'+i" [ngClass]="{'selected': cause?.selected && section.link}" (click)="toggle(cause, i)">
      <div [hidden]="cause?.selected" [class]="cause.icon"></div>
      <div [hidden]="cause?.selected" class="divider small" [ngClass]="section?.class"></div>
      <h5 [hidden]="cause?.selected" class="title">{{cause.text}}</h5>
      <div [hidden]="cause?.selected" class="link">{{cause.link}}</div>
      <div [hidden]="!cause?.selected" class="title font15">{{cause.invertText}}</div>
    </button>
  </div>
</ng-template>

<app-sac-button id="leadForm" hidden="true" [openLead]="true"></app-sac-button>
